import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { validateEnvironment } from './utils/constants'

// Validate environment variables before starting the app
try {
  validateEnvironment();
} catch (error) {
  console.error('Environment validation failed:', error);
  // Don't prevent app from starting, just log the error
}

createRoot(document.getElementById("root")!).render(<App />);
